import Hammer from 'hammerjs';

const $ = window.jQuery;

class PostGallery {
  constructor($element) {
    this.$element = $element;
    this.$items = this.$element.find('.post-gallery-item');
    this.$activeElement = this.$element.find('.post-gallery-item.active');
    this.$parent = $('.post');
    this.isOpen = false;

    this.addListeners();
  }

  addListeners() {
    $('body').keydown((e) => {
      if (e.keyCode == 37) {
        this.previous();
      } else if (e.keyCode == 39) {
        this.next();
      }
    });

    $('.post-gallery-open').click(() => {
      this.open();
    });

    $('.post-gallery-close').click(() => {
      this.close();
    });

    $('.post-gallery-item-previous').click(() => {
      this.previous();
    });

    $('.post-gallery-item-next').click(() => {
      this.next();
    });

    this.addTouchEvents();
  }

  addTouchEvents() {
    let $window = $(window);
    let panstart = false;
    let windowWidth = $window.width();

    this.$items.each((index, element) => {
      let hammertime = new Hammer(element, {direction: Hammer.DIRECTION_HORIZONTAL});

      hammertime.on('pan', (e) => {
        if (windowWidth >= 768) return;
        let percentChange = (e.deltaX / windowWidth) * 100;
        let translateValue = percentChange;
        let $currentTarget = $(e.target).closest('.post-gallery-item');
        if (panstart) {
          $currentTarget.css({
            'transform': 'translateX(' + translateValue + '%)',
            'transition': 'none'
          });
          if (Math.abs(percentChange) >= 33.33) {
            panstart = false;
            $currentTarget.css('transition', '');
            if (percentChange < 0) {
              this.next();
            } else {
              this.previous();
            }
            $currentTarget.css('transform', '');
          }
        }
      });

      hammertime.on('panstart', function (e) {
        panstart = true;
        $(e.target).closest('.post-gallery-item').css('transition', 'none');
      });

      hammertime.on('panend', function (e) {
        panstart = false;
        $(e.target).closest('.post-gallery-item').css({'transform': '', 'transition': ''});
      });
    });

    $window.on('resize orientationchange', function () {
      windowWidth = $window.width();
    });
  }

  previous() {
    if (this.$activeElement.is(':first-child')) {
      if (this.isOpen) this.close();
      return;
    }
    this.setActiveElement(this.$activeElement.prev());
    this.$parent.removeClass('gallery-animate-init gallery-animate-open gallery-animate-closed');
  }

  next() {
    if (!this.isOpen) {
      this.open();
      return;
    }
    if (this.$activeElement.is(':last-child')) {
      window.location.href = $('.post-gallery-next-series a').attr('href');
      return;
    }
    this.setActiveElement(this.$activeElement.next());
    this.$parent.removeClass('gallery-animate-init gallery-animate-open gallery-animate-closed');
  }

  open() {
    this.isOpen = true;
    $('.site-header-top-bar .post-gallery-close').addClass('gallery-open');
    this.$parent
      .addClass('gallery-open')
      .addClass('gallery-animate-open')
      .removeClass('gallery-animate-closed');
  }

  close() {
    this.isOpen = false;
    $('.site-header-top-bar .post-gallery-close').removeClass('gallery-open');
    this.$parent
      .removeClass('gallery-open')
      .removeClass('gallery-animate-open')
      .addClass('gallery-animate-closed');
    this.setCtaText();
  }

  setCtaText() {
    if (this.$activeElement.is(':first-child')) {
      $('.post-gallery-open.cta').removeClass('cta-resume');
    } else {
      $('.post-gallery-open.cta').addClass('cta-resume');
    }
  }

  setActiveElement($element) {
    let $formerActiveElement = this.$activeElement;
    this.$activeElement = $element;
    this.setClasses($formerActiveElement);
  }

  setClasses($formerActiveElement) {
    this.$items.removeClass('former-previous former-active former-next before after previous active next preview');
    $formerActiveElement.addClass('former-active');
    $formerActiveElement.prev().addClass('former-previous');
    $formerActiveElement.next().addClass('former-next');
    this.$activeElement.addClass('active');
    this.$activeElement
      .prev().addClass('previous')
      .prevAll().addClass('before');
    this.$activeElement
      .next().addClass('next')
      .nextAll().addClass('after');
    if (this.$activeElement.is(':last-child')) {
      this.$parent.addClass('gallery-end');
    } else {
      this.$parent.removeClass('gallery-end');
    }
  }
}

new PostGallery($('.post-gallery'));
